import React, { useEffect, useState } from "react";
import { getData } from "../../../Services/Services";
import { getThemeURL } from "../../../Services/EndPoints";
import CreateRoute from "./CreateRoute";
import RouteList from "./RouteList";
import AssignRoute from "./AssignRoute";
import { useLocation, useNavigate } from "react-router-dom";
import "./RouteEnhancements.css";

const ExpectedTrackForm = ({ onTabChange, onEditModeChange }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { data, edit, editRoute, routeData, routePoints} = location.state || {};
    
    const [activeTab, setActiveTab] = useState('create');
    const [userId, setUserId] = useState(null);
    const [editState, setEditState] = useState({
        isEdit: editRoute || false,
        routeData: routeData || null,
        routePoints: routePoints || []
    });

    const handleEditModeChange = (editStatus) => {
        if (onEditModeChange) {
            onEditModeChange(editStatus);
        }
    };

    useEffect(() => {
        if (editRoute && routeData) {
            setActiveTab('create');
            setEditState({
                isEdit: true,
                routeData: routeData,
                routePoints: routePoints || []
            });
            handleEditModeChange(true);
        } else if (edit && data) {
            setActiveTab('assign');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editRoute, routeData, edit, data]);

    useEffect(() => {
        if (onTabChange) {
            onTabChange(activeTab);
        }
        fetchUserProfile();
        
        // if (activeTab !== 'create') {
        //     setEditState({
        //         isEdit: false,
        //         routeData: null,
        //         routePoints: []
        //     });
        // }
        if (activeTab === 'list' || activeTab === 'assign') {
            // Don't clear edit state, just switching tabs temporarily
        }
    }, [activeTab, onTabChange]);

    const fetchUserProfile = async () => {
        try {
            const response = await getData(getThemeURL);
            if (response && Array.isArray(response) && response.length > 0) {
                setUserId(response[0].id);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };

    const handleUpdateSuccess = () => {
        setEditState({
            isEdit: false,
            routeData: null,
            routePoints: []
        });
        
        navigate(location.pathname, { replace: true, state: {} });
        
        setActiveTab('list');
        handleEditModeChange(false);
    };

    const tabConfig = {
        create: {
            icon: "fas fa-plus-circle",
            label: editState.isEdit ? 'Edit Route' : 'Create Route',
            subtitle: editState.isEdit ? 'Modify route waypoints' : 'Point-to-point route',
        },
        list: {
            icon: "fas fa-list-alt",
            label: "Route List",
            subtitle: "Browse & manage routes",
        },
        assign: {
            icon: "fas fa-route",
            label: "Assign Route",
            subtitle: "Schedule vehicle routes",
        }
    };

    return (
        <div className="container-fluid p-2 bg-light min-vh-100">
            {/* ── Tab Navigation ──────────────────────────────────────────── */}
            <div style={{
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                marginBottom: 16,
                padding: "8px",
                display: "flex",
                gap: 6,
            }}>
                {Object.entries(tabConfig).map(([key, config]) => {
                    const isActive = activeTab === key;
                    return (
                        <button
                            key={key}
                            className="route-tab-btn"
                            data-active={isActive ? 'true' : 'false'}
                            onClick={() => setActiveTab(key)}
                            style={{
                                flex: "0 0 auto",
                                padding: "7px 14px",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: 8,
                                background: isActive
                                    ? "linear-gradient(to right, #0f3d3a 0%, #0f4a45 50%, #1a7a73 100%)"
                                    : "transparent",
                                color: isActive ? "#ffffff" : "#64748b",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 9,
                                transition: "all 0.2s ease",
                                boxShadow: isActive ? "0 3px 12px rgba(26,122,115,0.28)" : "none",
                            }}
                        >
                            {/* Icon */}
                            <div style={{
                                width: 30, height: 30,
                                borderRadius: 7,
                                background: isActive ? "rgba(255,255,255,0.18)" : "transparent",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                flexShrink: 0,
                            }}>
                                <i className={config.icon} style={{
                                    fontSize: 14,
                                    padding: "0px",
                                    color: isActive ? "#ffffff" : "#94a3b8",
                                }} />
                            </div>

                            {/* Label + subtitle */}
                            <div style={{ textAlign: "left" }}>
                                <div style={{
                                    fontSize: 12,
                                    fontWeight: isActive ? 700 : 500,
                                    color: isActive ? "#ffffff" : "#64748b",
                                    lineHeight: 1.3,
                                    letterSpacing: "0.1px",
                                }}>
                                    {config.label}
                                </div>
                                <div style={{
                                    fontSize: 10,
                                    color: isActive ? "rgba(255,255,255,0.75)" : "#b0bec5",
                                    marginTop: 1,
                                    fontWeight: 400,
                                    lineHeight: 1.3,
                                }}>
                                    {config.subtitle}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>

            {/* ── Tab Content ─────────────────────────────────────────────── */}
            <div className="tab-content">
                <div className="fade show active">
                    <div className="card border-0" style={{
                        boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                        borderRadius: 12,
                        overflow: "hidden",
                    }}>
                        <div className="card-body" style={{ padding: 16 }}>
                            {activeTab === 'create' && (
                                <CreateRoute
                                    userId={userId}
                                    isEdit={editState.isEdit}
                                    routeData={editState.routeData}
                                    routePoints={editState.routePoints}
                                    onUpdateSuccess={handleUpdateSuccess}
                                />
                            )}
                            {activeTab === 'list' && (
                                <RouteList />
                            )}
                            {activeTab === 'assign' && (
                                <AssignRoute
                                    userId={userId}
                                    edit={edit}
                                    editData={data}
                                    onEditModeChange={handleEditModeChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
.bg-light-hover:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    transform: translateY(-1px);
    transition: all 0.3s ease;
}

.shadow-inner {
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.1) !important;
}

.transition-all {
    transition: all 0.3s ease;
}

.tab-content > .active {
    animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.card-body::-webkit-scrollbar {
    width: 6px;
}

.card-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.card-body::-webkit-scrollbar-thumb {
    background: #1a7a73;
    border-radius: 3px;
}

.card-body::-webkit-scrollbar-thumb:hover {
    background: #3a7a94;
}
`}</style>
        </div>
    );
};

export default ExpectedTrackForm;